﻿(function () {
    'use strict';

    var serviceId = 'repository.trackingServiceSearch';

    angular
        .module('app.services')
        .factory(serviceId, trackingServiceSearch);

    trackingServiceSearch.$inject = ['common', 'repository.abstract'];

    function trackingServiceSearch(common, abstractRepository) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;

            this.myFunction = myFunction;
        }
        abstractRepository.extend(Ctor);

        return Ctor;

        function myFunction() {

        }

    }
})();